module.exports = __webpack_public_path__ + "static/dev7-d07c2d6f779312806b34512409018032.png";